import axios from '@/axiosInterceptor';

const state = () => ({
  insurancePolicies: null,
  latest_exclusions: [],
  carrierInsurancePolicies: [],
  displayInsuranceModal: false,
});

// getters
const getters = {
  getHasFileCargo: (state) => {
    if (!state.insurancePolicies) return false;
    const destructured = [...state.insurancePolicies];
    const cargo = destructured?.find(
      (insurance) =>
        insurance?.is_type === 'motor_truck_cargo' &&
        insurance?.status === 'active'
    );
    return !!cargo;
  },
  getHasFileAuto: (state) => {
    if (!state.insurancePolicies) return false;
    const destructured = [...state.insurancePolicies];
    const auto = destructured?.find(
      (insurance) =>
        insurance?.is_type === 'automobile_liability' &&
        insurance?.status === 'active'
    );
    return !!auto;
  },
};

// actions
const actions = {
  async getPolicy({ commit }, carrierId) {
    try {
      const res = await axios.get(
        `${process.env.API_MONITOR}/api/v1/insurance_policies/active_by_carrier_id?carrier_id=${carrierId}`
      );
      commit('setInsurancePolicies', res.data);
      return res;
    } catch (e) {
      const status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getPolicyByCarrier({ commit }, id) {
    const params = {
      carrier_id: id,
    };
    try {
      const res = await axios.get(
        process.env.API_MONITOR +
          '/api/v1/insurance_policies/active_by_carrier_id?with_cancelled=true&with_active_pending=true',
        { params }
      );
      commit('setCarrierInsurancePolicies', res?.data);
      return res;
    } catch (e) {
      const status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },

  async getInsuranceCertificateRequests({ commit }, carrier_id) {
    try {
      let res = await axios.get(
        process.env.API_IDENTITY +
          '/api/v1/insurance_certificate_requests?q[carrier_id_eq]=' +
          carrier_id +
          '&q[status_not_eq]=cancelled&q[s]=created_at+desc'
      );
      if (res?.data) {
        commit('setInsuranceCertificateRequests', res?.data);
      }
      return res;
    } catch (e) {
      let status = e?.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async createCargoPolicyRequest() {
    try {
      const res = await axios.post(
        `${process.env.API_MONITOR}/api/v1/insurance_certificate_requests/create_cargo_policy_request`
      );
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422, 500].includes(status)
      ) {
        throw e;
      } else {
        throw e;
      }
    }
  },
  async searchAgencies(_, body) {
    const params = {
      page: '1',
      per_page: '10',
      'q[name_matches]': '%' + body.searchText + '%',
    };
    try {
      const res = await axios.get(
        process.env.API_MONITOR + '/api/v1/insurance_producers',
        {
          params,
        }
      );
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async uploadCargoPolicy(_, fileData) {
    const formData = new FormData();
    formData.append('insurance_cargo_policy[attachment]', fileData);

    try {
      const res = await axios.post(
        process.env.API_MONITOR + '/api/v1/insurance_cargo_policies',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      return res;
    } catch (e) {
      const status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async insuranceCertificateRequest(_, body) {
    try {
      const res = await axios.post(
        process.env.API_MONITOR + '/api/v1/insurance_certificate_requests',
        body
      );
      return res;
    } catch (e) {
      const status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
};

const mutations = {
  setInsurancePolicies(state, data) {
    state.insurancePolicies = data;
  },
  setLatestExclusions(state, data) {
    state.latest_exclusions = data;
  },
  setCarrierInsurancePolicies(state, policies) {
    state.carrierInsurancePolicies = policies;
  },
  setInsuranceCertificateRequests(state, requests) {
    state.certificateRequests = requests;
  },
  setDisplayInsuranceModal(state, data) {
    state.displayInsuranceModal = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
